import { useTranslation } from "react-i18next";

export const AwsConfigAuth = {
    region: process.env.REACT_APP_AUTH_REGION,
    userPoolId: process.env.REACT_APP_AUTH_USER_POOL_ID,
    userPoolWebClientId: process.env.REACT_APP_AUTH_USER_POOL_WEB_CLIENT_ID,
    cookieStorage: {
        domain: process.env.REACT_APP_AUTH_COOKIE_STORAGE_DOMAIN,
        path: "/",
        expires: 0.5,
        sameSite: "strict",
        // Set as false if on localhost, true if on any other domain. This allows the sso portal to work on safari when running locally.
        secure: process.env.REACT_APP_AUTH_COOKIE_STORAGE_DOMAIN !== "localhost"
    },
    authenticationFlowType: "USER_SRP_AUTH"
};

if (process.env.REACT_APP_AUTH_COOKIE_STORAGE_DOMAIN === "localhost") {
    AwsConfigAuth.cookieStorage.sameSite = "lax";
    AwsConfigAuth.cookieStorage.secure = false;
}

export const AmplifyLoginFields = {
    Fields() {
        const { t } = useTranslation("locale");
        return {
            signIn: {
                username: {
                    label: t("auth.email_label"),
                    labelHidden: false,
                    placeholder: t("auth.email_placeholder")
                },
                password: {
                    labelHidden: false,
                    label: t("auth.password_label"),
                    placeholder: t("auth.password_placeholder")
                }
            },
            signUp: {
                username: {
                    labelHidden: false,
                    label: t("auth.email_label"),
                    placeholder: t("auth.email_placeholder"),
                    isRequired: true
                },
                ["custom:full_name"]: {
                    labelHidden: false,
                    label: t("auth.name_label"),
                    isRequired: true
                },
                "custom:organisation": {
                    labelHidden: false,
                    label: t("auth.organisation_label"),
                    isRequired: true
                },
                phone_number: {
                    labelHidden: false,
                    label: t("auth.phone_label"),
                    isRequired: true,
                    dialCode: "+44"
                },
                "custom:mobile_number": {
                    labelHidden: false,
                    label: t("auth.mobile_label")
                },
                password: {
                    labelHidden: false,
                    label: t("auth.password_label"),
                    placeholder: t("auth.password_placeholder"),
                    isRequired: true
                },
                confirm_password: {
                    labelHidden: false,
                    label: t("auth.confirm_password_label"),
                    placeholder: t("auth.confirm_password_placeholder"),
                    isRequired: true
                }
            },
            forceNewPassword: {
                password: {
                    labelHidden: false,
                    placeholder: t("auth.password_placeholder")
                }
            },
            resetPassword: {
                username: {
                    label: t("auth.email_label"),
                    labelHidden: false,
                    placeholder: t("auth.email_placeholder")
                }
            },
            confirmResetPassword: {
                confirmation_code: {
                    labelHidden: false,
                    placeholder: t("auth.confirm_reset_code_placeholder"),
                    label: t("auth.confirm_reset_code_label"),
                    isRequired: false
                },
                confirm_password: {
                    labelHidden: false,
                    placeholder: t("auth.confirm_password_placeholder")
                }
            },
            confirmSignIn: {
                confirmation_code: {
                    labelHidden: false,
                    placeholder: t("auth.confirm_code_placeholder"),
                    label: t("auth.confirm_code_label"),
                    isRequired: false
                }
            }
        };
    }
};
